var map = {
	"./AdventCalendar": 37381,
	"./Adverts": 40185,
	"./Balance": 50645,
	"./CasinoFilters": 56052,
	"./CasinoGameLauncher": 89936,
	"./CasinoGameModal": 24381,
	"./CasinoGames": 71714,
	"./FreebetBonuses": 22566,
	"./JackpotAggregatorCampaignView": 20375,
	"./JackpotAggregatorWinnerWins": 72411,
	"./Lottery": 14292,
	"./OtpAttempt": 65765,
	"./PaymentForm": 9156,
	"./PlaytechGallery": 82081,
	"./PlaytechWebClient": 24582,
	"./QuickSignupForm": 43819,
	"./Tournament": 30795,
	"./TwofaActivationForm": 74288,
	"./UserToUserTransferState": 50509,
	"./WageringBonuses": 55297,
	"./useBalance": 90898,
	"./useInputErrorsDebouncer": 5599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31205;